import type { AccountInfo } from "@azure/msal-browser";

import type { Account } from "./types";

export function normalizeAccount(accInfo: AccountInfo | any): Account {
  const displayName =
    accInfo?.name ||
    accInfo?.idTokenClaims?.name ||
    accInfo?.idTokenClaims?.preferred_username ||
    accInfo?.username ||
    "";
  const email = accInfo?.idTokenClaims?.email || accInfo?.username || "";
  return {
    id: accInfo?.homeAccountId || accInfo?.localAccountId,
    username: accInfo?.username || email,
    displayName,
    email,
  } as Account;
}
